export const addMinutesToTime = (time, amount) => {
    const timeArr = time.split(':');
    const minutes = Number(timeArr[1]) + Number(amount);
    
    return `${Number(timeArr[0]) + (minutes > 59 ? 1 : 0)}:${minutes % 60 <= 9 ? '0' : ''}${minutes % 60}`
}